import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const PropertyHeader = ({ property }) => {
  const getPortalLogo = (url) => {
    if (url?.includes('domain.com.au')) {
      return {
        name: 'Domain',
        color: '#00A86B'
      };
    } else if (url?.includes('realestate.com.au')) {
      return {
        name: 'REA',
        color: '#E4002B'
      };
    }
    return null;
  };

  const portal = getPortalLogo(property?.listingUrl);

  return (
    <div className="w-full bg-card rounded-lg border border-border overflow-hidden shadow-elevation-md">
      <div className="relative w-full h-64 md:h-80 lg:h-96 overflow-hidden">
        <Image
          src={property?.image}
          alt={property?.imageAlt}
          className="w-full h-full object-cover"
        />
        {portal && (
          <div 
            className="absolute top-4 right-4 px-4 py-2 rounded-lg shadow-elevation-lg flex items-center gap-2"
            style={{ backgroundColor: portal?.color }}
          >
            <Icon name="ExternalLink" size={16} color="#FFFFFF" />
            <span className="text-sm font-semibold text-white font-body">
              {portal?.name}
            </span>
          </div>
        )}
      </div>
      <div className="p-4 md:p-6 lg:p-8">
        <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-4">
          <div className="flex-1 min-w-0">
            <h1 className="text-2xl md:text-3xl lg:text-4xl font-semibold text-foreground mb-2">
              {property?.address}
            </h1>
            <p className="text-base md:text-lg text-muted-foreground font-body">
              {property?.suburb}, {property?.state} {property?.postcode}
            </p>
          </div>

          <div className="flex flex-wrap gap-4 lg:gap-6">
            <div className="flex items-center gap-2">
              <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg bg-primary/10 flex items-center justify-center">
                <Icon name="Bed" size={20} color="var(--color-primary)" />
              </div>
              <div>
                <div className="text-xs md:text-sm text-muted-foreground text-caption">Bedrooms</div>
                <div className="text-lg md:text-xl font-semibold text-foreground text-data">
                  {property?.bedrooms}
                </div>
              </div>
            </div>

            <div className="flex items-center gap-2">
              <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg bg-primary/10 flex items-center justify-center">
                <Icon name="Bath" size={20} color="var(--color-primary)" />
              </div>
              <div>
                <div className="text-xs md:text-sm text-muted-foreground text-caption">Bathrooms</div>
                <div className="text-lg md:text-xl font-semibold text-foreground text-data">
                  {property?.bathrooms}
                </div>
              </div>
            </div>

            <div className="flex items-center gap-2">
              <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg bg-primary/10 flex items-center justify-center">
                <Icon name="Car" size={20} color="var(--color-primary)" />
              </div>
              <div>
                <div className="text-xs md:text-sm text-muted-foreground text-caption">Parking</div>
                <div className="text-lg md:text-xl font-semibold text-foreground text-data">
                  {property?.parking}
                </div>
              </div>
            </div>
          </div>
        </div>

        {property?.pricingGuide && (
          <div className="mt-4 md:mt-6 pt-4 md:pt-6 border-t border-border">
            <div className="flex items-center gap-2">
              <Icon name="DollarSign" size={20} color="var(--color-accent)" />
              <span className="text-sm text-muted-foreground text-caption">Pricing Guide:</span>
              <span className="text-lg md:text-xl font-semibold text-foreground text-data">
                {property?.pricingGuide}
              </span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PropertyHeader;